angular.module('app.filters', []).filter('range', function() {
  return function(input, total) {
    var i, j, ref;
    total = parseInt(total);
    for (i = j = 0, ref = total; (0 <= ref ? j <= ref : j >= ref); i = 0 <= ref ? ++j : --j) {
      input.push(i);
    }
    return input;
  };
}).filter('nl2br', function() {
  return function(string) {
    if (typeof string !== 'string') {
      return '';
    }
    return string.replace(/\n/g, '<br />');
  };
}).filter('join', function() {
  return function(array) {
    return array.filter(function(item) {
      return !!item;
    }).join(' ');
  };
}).filter('slug', function() {
  return function(string) {
    return string.trim().toLowerCase().replace(/[\W_]+/g, '-').replace(/^-+|-+$/g, '');
  };
}).filter('location', function() {
  return function(object) {
    var array;
    array = [];
    if (object.street) {
      array.push(object.street + ",");
    }
    if (object.postcode) {
      array.push(object.postcode);
    }
    if (object.location) {
      array.push(object.location);
    }
    return encodeURI(array.join(' '));
  };
}).filter('time', [
  '$filter',
  function($filter) {
    return function(input,
  arg) {
      var date,
  parts;
      if (input == null) {
        return;
      }
      parts = input.split(':');
      date = new Date(0,
  0,
  0,
  parts[0],
  parts[1],
  parts[2]);
      return $filter('date')(date,
  arg || 'HH:mm');
    };
  }
]).filter('matches', function() {
  return function(string, length, offset) {
    var after, before, match;
    before = string.substring(0, offset);
    after = string.substring(offset + length);
    match = string.substring(offset, length);
    return `${before}<b>${match}</b>${after}`;
  };
});
